import axios from 'axios';
import config from '../config';
import Session from './SessionProvider';

const baseurl = config.api[config.stage].baseurl;
let headers   = {};

if (Session.getToken()) {
  headers = {
    'Authorization': `Bearer ${Session.getToken()}`,
  }
}

class AttributesProvider {
  static async create(data) {
    return await axios({
      mode: 'no-cors',
      method: 'POST',
      url: `${baseurl}attributes`,
      crossdomain: true,
      headers,
      data,
    })
    .then((json) => json.data)
    .then(res => res)
    .catch((err) => {
      if (err.response) return err.response.data;
      return err;
    });
  }

  static async update(id, data) {
    return await axios({
      mode: 'no-cors',
      method: 'PUT',
      url: `${baseurl}attributes/${id}`,
      crossdomain: true,
      headers,
      data,
    })
    .then((json) => json.data)
    .then(res => res)
    .catch((err) => {
      if (err.response) return err.response.data;
      return err;
    });
  }

  static async getAll(offset=config.results.offset, limit=config.results.limit, filters=null) {
    return await axios({
      mode: 'no-cors',
      method: 'GET',
      url: `${baseurl}attributes?offset=${offset}&limit=${limit + (filters ? `&${filters}` : '')}`,
      crossdomain: true,
      headers
    })
    .then((json) => json.data)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response) return err.response.data;
      return err;
    });
  }

  static async get(id) {
    return await axios({
      mode: 'no-cors',
      method: 'GET',
      url: `${baseurl}attributes/${id}`,
      crossdomain: true,
      headers
    })
    .then((json) => json.data)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response) return err.response.data;
      return err;
    });
  }

  static async destroy(id) {
    return await axios({
      mode: 'no-cors',
      method: 'DELETE',
      url: `${baseurl}attributes/${id}`,
      crossdomain: true,
      headers,
    })
    .then((json) => json.data)
    .then(res => res)
    .catch((err) => {
      if (err.response) return err.response.data;
      return err;
    });
  }
}

export default AttributesProvider;
